import {
  INVALID_EMAIL,
  NO_EMAIL,
} from '@/common/constants/account-credentials-validation-errors';

const reEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export interface EmailValidation {
  empty: boolean;
  valid: boolean;
  errorMessage: string;
}

export function validateEmail(email = ''): EmailValidation {
  const empty = email === '';
  const valid = reEmail.test(email);
  const errorMessage = empty ? NO_EMAIL : valid ? '' : INVALID_EMAIL;
  return { empty, valid, errorMessage };
}
